import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, " 暂无数据 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _ctx.zhCN }, {
    renderEmpty: _withCtx(() => [
      _createVNode(_component_a_empty, { image: _ctx.simpleImage }, {
        description: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["image"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_router_view, {
        class: _normalizeClass({'xp': _ctx.os === 'xp'})
      }, null, 8, ["class"])
    ]),
    _: 1
  }, 8, ["locale"]))
}